import { useObservable } from '@mindspace-io/react';
import { facade } from './WebsitesFacade';
import { websitesQuery, websitesStore } from './WebsitesStore';

export function useActiveWebsite() {
  const [activeWebsite] = useObservable(
    websitesQuery.activeWebsite$,
    undefined
  );

  return activeWebsite;
}

export function useWebsiteList() {
  const [websites] = useObservable(websitesQuery.websites$, []);

  return websites;
}

export function useWebsitesStoreLoading() {
  const [isLoading] = useObservable(
    websitesQuery.loading$,
    websitesStore.getValue().loading
  );

  return isLoading;
}

export function useWebsitesFacade() {
  return facade;
}

export function useWebsitesFetched() {
  return websitesQuery.getHasCache();
}
